import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
    <span
        className={`eyebrow inline-block px-3 py-1.5 rounded-sm border ${
            light
                ? "text-red-300 bg-red-500/10 border-red-400/30"
                : "text-red-700 bg-red-50/80 border-red-200/60"
        }`}
    >
        {children}
    </span>
);
